<template>
  <div class="reg-auth-forgot__tabs">
    <UiTabs
      :tabs="tabsList"
      :query="false"
      :value="activeTab"
      @input="changeTab"
    />
  </div>
</template>

<script>
import UiTabs from '@/components/ui/UiTabs'
import { GTM_REG } from '@/constants/gtm'

export default {
  name: 'RegAuthForgotTabs',
  components: { UiTabs },
  computed: {
    activeTab() {
      return this.$route.query.bigModalTab || ''
    },
    isRegister() {
      return this.$route.query.bigModal === 'registration'
    },
    tabsList() {
      return [
        {
          id: 'phone',
          title: this.$t('regAuthForgot.phone'),
          dataId: 'register-tabs-phone-link',
          dataGtmId: this.isRegister ? GTM_REG.ID.ga_registration_click_btn_choose_methode : '',
        },
        {
          id: 'email',
          title: this.$t('regAuthForgot.email'),
          dataId: 'register-tabs-email-link',
          dataGtmId: this.isRegister ? GTM_REG.ID.ga_registration_click_btn_choose_methode : '',
        },
      ]
    },
  },
  methods: {
    changeTab(newTab) {
      if (this.activeTab === newTab) return
      this.$newModal.changeQueryParam('bigModalTab', newTab)
    },
  },
}
</script>

<style lang="scss" scoped>
.reg-auth-forgot__tabs {
  &::v-deep .tabs {
    &__buttons {
      width: 100%;
    }
    &__item {
      width: 50%;
      margin-right: 0;
    }
  }
}
</style>
